import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import frontImage from '../assets/frontImage.png';


const API_URL = process.env.REACT_APP_API_URL;

export default function SignInPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignIn = async () => {
    setError('');
    setLoading(true);

    const trimmedUsername = username.trim().toLowerCase();
    const trimmedPassword = password.trim();

    try {
      const res = await fetch(`${API_URL}/get-users`);
      if (!res.ok) throw new Error('Failed to fetch users.');

      const users = await res.json();

      const match = users.find(
        (user: any) =>
          user.username?.toLowerCase() === trimmedUsername &&
          user.password === trimmedPassword
      );

      if (!match) {
        setError('Invalid username or password.');
      } else if (match.userType?.toLowerCase() === 'master') {
        navigate('/admin', { state: { user: match } });
      } else {
        navigate('/upload', { state: { user: match } });
      }
    } catch (err: any) {
      console.error('Login error:', err);
      setError('Unable to sign in. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') handleSignIn();
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md bg-white p-8 rounded-2xl shadow-lg">
        <img
          src={frontImage}
          alt="Company Logo"
          className="mx-auto mb-[-30px] h-[200px] w-auto"
        />
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">Sign In</h2>

        {error && <div className="text-red-500 text-sm mb-4 text-center">{error}</div>}

        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          onKeyDown={handleKeyDown}
          className="w-full p-3 mb-4 border rounded-xl focus:outline-none focus:ring focus:border-blue-300"
          disabled={loading}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleKeyDown}
          className="w-full p-3 mb-6 border rounded-xl focus:outline-none focus:ring focus:border-blue-300"
          disabled={loading}
        />

        <button
          onClick={handleSignIn}
          className="w-full bg-blue-600 text-white p-3 rounded-xl hover:bg-blue-700 transition"
          disabled={loading}
        >
          {loading ? 'Signing In...' : 'Sign In'}
        </button>
      </div>
    </div>
  );
}
